'use client';

import { Metroline } from '@mv/web-ui';
import RichText, { type RichTextOptions } from '@/payload/components/RichText/RichText';
import type { MetrolineBlock as MetrolineBlockProps } from '@/payload/types';

type Props = MetrolineBlockProps & {
	options?: RichTextOptions;
};

export default function MetrolineBlock({ items, options }: Props) {
	return (
		<Metroline data-component="MetrolineBlock">
			{items?.map(({ id, richText }, index) => (
				<Metroline.Item number={index + 1} key={id}>
					<RichText content={richText} options={options} />
				</Metroline.Item>
			))}
		</Metroline>
	);
}
